import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class AsideMedium extends Component {
  render() {
    if( this.props.width !== undefined && this.props.width[1] >= 992 ) return '';

    const user = this.props.user;

    return (
      <aside className="page-aside aside_medium">
        <button className="aside_medium__bg" onClick={ this.props.handleAsideToggle }></button>
        <div className="aside_medium__wrap">
          <header>
            <Link className={'aside__title aside__title_blue'+( user ? ' hide' : '' )} to="/login">Вход в Личный кабинет</Link>
            <div className={'aside__title aside__title_blue'+( user ? '' : ' hide' )}>
              <span>{ user && user.email }</span>
            </div>
          </header>

          <section className="aside__menu">
            <ul>
              <li>
                <h3 className="aside__title">Меню</h3>
                <ul>
                  { this.props.menu.map( (v,i) => (
                    i ? <li key={i}><Link className="aside__menu__item" to={ '/'+v.uri }>{ v.menutitle ? v.menutitle : v.pagetitle }</Link></li> : ''
                  ))}
                </ul>
              </li>
              <li className={!user?'hide':''}>
                <h3 className="aside__title">Информация о подписке</h3>
                <ul>
                  {this.props.licenses && this.props.licenses.map((v,i) => (
                    <li key={i}><Link className="aside__menu__item" to={ '/cabinet/#'+i }>{ v.title }</Link></li>
                  ))}
                  <li><button className="aside__menu__item" onClick={ this.props.handleSignout }>Выйти</button></li>
                </ul>
              </li>
              <li>
                <Link className="aside__title" to="/infobase">База знаний</Link>
              </li>
            </ul>
          </section>

          <section className="contacts">
            <h3 className="aside__title">Контакты</h3>
            <p className="aside__description">{ this.props.address }<br/><a href={`tel:${ this.props.phoneHref }`}>{ this.props.phone }</a></p>
          </section>

          <footer>
            <ul className="list_links">

              { this.props.emails.map( (v,i) => (
                <li key={i}><a href={`mailto:${v}`}>{v}</a></li>
              ))}

              <li><a href={ this.props.basesite }>{ this.props.basesite }</a></li>
            </ul>
          </footer>
        </div>
      </aside>
    );
  }
}
export default AsideMedium;
